// extracted by css-extract-rspack-plugin
export default {"menuItem":"menuItem-w7uoAG","separatedItem":"separatedItem-_NuiRX","menuContent":"menuContent-D1XM7p","menuIcon":"menuIcon-Qsa5YN"};